export default {
  namespaced: true,
  actions: {
    getStatistics (context) {
      const promise = this.server.statistics()
      return promise
    },
    getDailyAnswers (context) {
      const promise = this.server.dailyAnswers()
      return promise
    }
  }
}
